(() => {
const SHOP = window.MM_SHOP || { root:'/', assets:{}, products:{} };
const A = name => SHOP.assets[name] || name;
const FLAVOURS = [
  { id:'vanille',   word:'Vanille',   name:'Vanille de Madagascar', desc:'De vraies gousses, rien d’autre.',   bg:'#1D4F8F', fg:'#F3EEE4', card:'#F1DDA4', logo: 1.7 },
  { id:'chocolat',  word:'Chocolat',  name:'Chocolat hollandais',   desc:'Cacao hollandais, profond et doux.', bg:'#5A3424', fg:'#F3EEE4', card:'#5A3424', logo: 1.0 },
  { id:'pistache',  word:'Pistache',  name:'Pistache',              desc:'De vraies pistaches, pas de vert.',  bg:'#3D5A2C', fg:'#F3EEE4', card:'#3D5A2C', logo: 3.9 },
  { id:'framboise', word:'Framboise', name:'Framboise',             desc:'De vraies framboises.',              bg:'#C8285A', fg:'#F3EEE4', card:'#C8285A', logo:-4.7 },
];
const byId = Object.fromEntries(FLAVOURS.map(f => [f.id, f]));
const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
const $ = id => document.getElementById(id);
/* ================= langue : FR / EN ================= */
const EN = {
  // header, menu, footer
  'Boutique':'Shop', 'La maison':'Our story', 'Restaurants':'Restaurants', 'Athletics':'Athletics', 'Commander ·':'Order ·',
  'Saveurs':'Flavours', 'Meu Meu Athletics':'Meu Meu Athletics', 'Langue':'Language',
  'Ouvrir le menu':'Open the menu', 'Fermer le menu':'Close the menu', 'Meu Meu, accueil':'Meu Meu, home', 'Principale':'Main',
  'Commander : voir le panier':'Order: see the cart', 'Menu mobile':'Mobile menu', 'Pied de page':'Footer',
  'Crème anglaise glacée, 100 % naturelle. Artisan glacier depuis 1989.':'Frozen custard, 100% natural. Artisan ice cream maker since 1989.',
  'Montréal (Québec)':'Montréal, Québec', 'Le comptoir d’origine':'The original counter', 'Heures et itinéraire sur Google':'Hours and directions on Google',
  'La cuisine et la cueillette':'The kitchen and pickup', 'Itinéraire':'Directions', 'Nous joindre':'Contact us',
  '© 2026 Crémerie Meu Meu':'© 2026 Crémerie Meu Meu', 'Livraison à Montréal seulement':'Delivery in Montréal only',
  // hero
  'Vanille':'Vanilla', 'Chocolat':'Chocolate', 'Pistache':'Pistachio', 'Framboise':'Raspberry',
  'Vanille de Madagascar':'Madagascar Vanilla', 'Chocolat hollandais':'Dutch Chocolate',
  'De vraies gousses, rien d’autre.':'Real vanilla beans, nothing else.', 'Cacao hollandais, profond et doux.':'Dutch cocoa, deep and smooth.',
  'De vraies pistaches, pas de vert.':'Real pistachios, no green dye.', 'De vraies framboises.':'Real raspberries.',
  'Commander une pinte':'Order a pint', 'Chargement…':'Loading…', 'Nos quatre classiques':'Our four classics',
  'Saveur précédente':'Previous flavour', 'Saveur suivante':'Next flavour', 'Choisir une saveur':'Choose a flavour',
  'Le pot n’a pas pu être chargé. Rechargez la page.':'The pint couldn’t load. Please reload the page.',
  // shop
  'La pinte, chez vous.':'The pint, at home.',
  'Pintes de 500 ml, le coffret des quatre classiques et la bûche des fêtes. Livraison à Montréal chaque mardi, ou cueillette au Bocal.':'500 ml pints, the box of four classics and the holiday Yule log. Delivery in Montréal every Tuesday, or pickup at Bocal.',
  'Livraison gratuite à Montréal':'Free delivery in Montréal', 'dès 44 $':'from $44',
  'Chaque mardi à partir du 10 novembre. Sous 44 $, la commande se fait en cueillette au Bocal.':'Every Tuesday from November 10. Under $44, orders are picked up at Bocal.',
  'Bientôt dans la boutique':'Coming soon to the shop', 'Trois saveurs à l’essai pour compléter les classiques.':'Three flavours in testing to join the classics.',
  'À venir':'Coming soon', 'Cardamome':'Cardamom', 'Épicée, douce, parfumée.':'Spiced, gentle, fragrant.', 'Lavande':'Lavender',
  'Florale et fraîche.':'Floral and fresh.', 'Biscuits & crème':'Cookies & cream', 'La saveur riche de la gamme.':'The rich one of the range.',
  'Ils en parlent':'In the press', 'La presse et nos clients.':'What the press and our customers say.',
  'Tastet · Critique':'Tastet · Review', 'Tastet · Guide':'Tastet · Guide',
  'Meu Meu : l’excellente crèmerie de la rue Saint-Denis':'Meu Meu: the excellent ice cream shop on Saint-Denis Street',
  'Où manger une bonne crème glacée rue Saint-Denis':'Find your perfect spot for ice cream on Rue Saint-Denis',
  'L’ultime bucket list des 21 meilleures crèmeries à Montréal':'The 21 best ice cream shops in Montréal (in French)',
  '« Plus qu’un dessert. Une expérience glacée. »':'“More than a dessert. A frozen experience.”',
  'Lire l’article':'Read the article', 'Avis Google':'Google reviews', '762 avis':'762 reviews', 'Lire les avis':'Read the reviews',
  '4,5 étoiles sur 5':'4.5 stars out of 5', '4,5':'4.5',
  // products
  'Le coffret des quatre':'The box of four', 'Bûche de Noël glacée':'Frozen Yule log', 'Idée cadeau':'Gift idea', 'Temps des fêtes':'Holidays',
  'Pinte de 500 ml. Cacao hollandais, profond et doux.':'500 ml pint. Dutch cocoa, deep and smooth.',
  'Pinte de 500 ml. De vraies gousses, rien d’autre.':'500 ml pint. Real vanilla beans, nothing else.',
  'Pinte de 500 ml. De vraies pistaches, pas de vert.':'500 ml pint. Real pistachios, no green dye.',
  'Pinte de 500 ml. De vraies framboises.':'500 ml pint. Real raspberries.',
  'Vanille, chocolat, pistache et framboise : quatre pintes de 500 ml.':'Vanilla, chocolate, pistachio and raspberry: four 500 ml pints.',
  '6 à 8 portions. Quantités limitées.':'Serves 6 to 8. Limited quantities.',
  'Un chocolat franc et rond, fait avec du cacao hollandais pur. Pas de pépites, pas de sirop : juste le cacao dans notre crème anglaise.':'A bold, round chocolate made with pure Dutch cocoa. No chips, no syrup: just cocoa in our custard base.',
  'La recette d’origine. Des gousses de vanille de Madagascar infusées dans la crème anglaise, et rien d’autre.':'The original recipe. Madagascar vanilla beans steeped in the custard, and nothing else.',
  'Des pistaches broyées dans la crème anglaise. Sa couleur vient de la noix, pas d’un colorant.':'Ground pistachios in the custard. The colour comes from the nut, not a dye.',
  'De vraies framboises dans une crème anglaise douce. Acidulée, fruitée, sans arôme ajouté.':'Real raspberries in a smooth custard. Tangy, fruity, no added flavouring.',
  'Nos quatre classiques réunis dans une boîte : vanille de Madagascar, chocolat hollandais, pistache et framboise. Toujours ces quatre saveurs, pour offrir ou pour soi.':'Our four classics in one box: Madagascar vanilla, Dutch chocolate, pistachio and raspberry. Always these four flavours, to give or to keep.',
  'La bûche glacée des fêtes, faite à Bocal par le chef Raphaël. Quantités limitées : réservez la vôtre avant le 15 décembre.':'The holiday frozen Yule log, made at Bocal by chef Raphaël. Limited quantities: reserve yours before December 15.',
  'Lait':'Milk', 'crème 10 %':'10% cream', 'jaunes d’œufs pasteurisés':'pasteurized egg yolks', 'sucre de canne bio':'organic cane sugar',
  'cacao hollandais':'Dutch cocoa', 'vanille de Madagascar':'Madagascar vanilla', 'pistaches':'pistachios', 'framboises':'raspberries',
  'Contient : lait et œufs. Peut contenir des traces de noix.':'Contains: milk and eggs. May contain traces of nuts.',
  'Contient : lait, œufs et noix (pistaches).':'Contains: milk, eggs and nuts (pistachios).',
  'Liste des ingrédients et des allergènes à venir.':'Ingredients and allergens to come.',
  'Ajouter':'Add', 'OK':'OK', 'Ajouté ✓':'Added ✓', 'Indisponible':'Unavailable', 'Retirer une':'Remove one', 'Ajouter une':'Add one',
  'Photo à venir':'Photo coming soon', 'Bûche':'Yule', 'de Noël':'log', 'Coffret':'Box',
  '← Boutique':'← Shop', 'Format':'Size', 'Ingrédients':'Ingredients', 'Allergènes':'Allergens', 'Conservation':'Storage',
  'Contenu':'Contents', 'Disponibilité':'Availability', 'Livraison':'Delivery',
  'Pinte de 500 ml':'500 ml pint', '6 à 8 portions':'Serves 6 to 8',
  'Garder congelé. Laisser tempérer 5 minutes avant de servir.':'Keep frozen. Let it soften for 5 minutes before serving.',
  'Garder congelé.':'Keep frozen.',
  '4 pintes de 500 ml : vanille de Madagascar, chocolat hollandais, pistache, framboise.':'4 × 500 ml pints: Madagascar vanilla, Dutch chocolate, pistachio, raspberry.',
  'Les mardis jusqu’au 22 décembre, ou cueillette au Bocal.':'Tuesdays until December 22, or pickup at Bocal.',
  'Précommandes terminées pour cette année.':'Pre-orders are closed for this year.', 'Épuisée. Merci !':'Sold out. Thank you!',
  'Il ne reste plus de bûches.':'No Yule logs left.', 'La bûche n’est plus disponible en cette quantité.':'The Yule log is no longer available in that quantity.',
  // cart + checkout
  'Votre commande':'Your order', 'Vos coordonnées':'Your details', 'Paiement':'Payment', 'Merci !':'Thank you!',
  'Panier':'Cart', 'Coordonnées':'Details', 'Étapes':'Steps', 'Fermer la commande':'Close the order',
  'Passer la commande':'Check out', 'Voir la commande':'View order', 'Sous-total':'Subtotal', 'Total':'Total', 'Gratuite':'Free',
  'Cueillette au Bocal':'Pickup at Bocal', 'TPS (5 %)':'GST (5%)', 'TVQ (9,975 %)':'QST (9.975%)',
  'Pintes de 500 ml, coffret et bûche : produits alimentaires détaxés (TPS et TVQ à 0 %).':'500 ml pints, box and Yule log are zero-rated food items (GST and QST at 0%).',
  'Votre commande est vide. Ajoutez une pinte pour commencer.':'Your order is empty. Add a pint to get started.',
  'Livraison ou cueillette':'Delivery or pickup', 'Livraison à Montréal':'Delivery in Montréal', 'Chaque mardi, au courant de la journée':'Every Tuesday, during the day',
  'Nom complet':'Full name', 'Courriel':'Email', 'Téléphone':'Phone', 'Adresse':'Address', 'App. (optionnel)':'Apt. (optional)', 'Code postal':'Postal code',
  'Ville':'City', 'Mardi de livraison':'Delivery Tuesday', 'Consignes (optionnel)':'Instructions (optional)',
  'Numéro et rue':'Number and street', 'Code de porte, laisser chez le voisin…':'Door code, leave with a neighbour…',
  'La livraison se fait seulement pour les commandes de 44 $ et plus. Complétez votre commande, ou passez la prendre au Bocal.':'Delivery is only for orders of $44 and up. Add to your order, or pick it up at Bocal.',
  '4551, rue de Rouen, Montréal':'4551 rue de Rouen, Montréal', 'Au Bocal, 4551, rue de Rouen':'At Bocal, 4551 rue de Rouen', 'Date de cueillette confirmée par courriel.':'Pickup date confirmed by email.', 'Client':'Customer', 'Cueillette':'Pickup', 'Articles':'Items', 'Nous vous écrirons pour confirmer la date de cueillette au Bocal.':'We’ll email you to confirm the pickup date at Bocal.',
  'La date de cueillette sera annoncée bientôt. Nous vous écrirons pour la confirmer.':'The pickup date will be announced soon. We’ll email you to confirm it.',
  'Retour':'Back', 'Continuer vers le paiement':'Continue to payment', 
    'Un instant…':'One moment…', 'Livraison ou cueillette':'Delivery or pickup', 'Total avant taxes':'Total before tax',
  'Vous entrerez vos coordonnées et votre carte à l’étape suivante, sur la page de paiement sécurisée de Shopify.':'You’ll enter your details and card at the next step, on Shopify’s secure payment page.',
  'Les taxes applicables et le mode de livraison sont confirmés à la page de paiement.':'Applicable taxes and the delivery method are confirmed on the payment page.',
  'La boutique n’est pas encore configurée.':'The shop isn’t set up yet.', 'Un produit n’est plus disponible en cette quantité.':'A product is no longer available in this quantity.',
  'Le paiement n’a pas pu s’ouvrir. Réessayez.':'The payment page could not open. Please try again.', 'Indisponible':'Unavailable',
    'Commande':'Order', 'reçue.':'received.', 'Un courriel de confirmation suivra.':'A confirmation email will follow.', 'Fermer':'Close',
  'Aucune date de livraison restante':'No delivery dates left', 'Entrez un numéro à 10 chiffres.':'Enter a 10-digit number.',
  'Cette année, nous livrons seulement sur l’île de Montréal (codes postaux en H, sauf Laval en H7). Choisissez la cueillette au Bocal si vous êtes à l’extérieur.':'This year we only deliver on the island of Montréal (postal codes starting with H, except Laval, H7). Choose pickup at Bocal if you’re outside it.',
  // La maison
  'Depuis':'Since', 'Une crèmerie de quartier sur la rue Saint-Denis. La même crème anglaise glacée depuis la première pinte, faite à la main en petits lots.':'A neighbourhood ice cream shop on rue Saint-Denis. The same frozen custard since the very first pint, made by hand in small batches.',
  '4458, rue Saint-Denis':'4458 rue Saint-Denis', '4551, rue de Rouen':'4551 rue de Rouen',
  'Le comptoir d’origine, sur le Plateau-Mont-Royal. La façade jaune, le néon dans la vitrine, la vache sur l’affiche.':'The original counter, on the Plateau-Mont-Royal. The yellow façade, the neon in the window, the cow on the sign.',
  'Les heures de la saison sont sur notre fiche Google.':'This season’s hours are on our Google listing.', 'Voir les heures sur Google':'See hours on Google',
  'Cinq ingrédients. C’est tout.':'Five ingredients. That’s all.',
  'Lait et crème de producteurs d’ici, jaunes d’œufs pasteurisés, sucre de canne biologique, et la saveur : de vraies gousses de vanille, du vrai cacao, de vraies pistaches, de vraies framboises.':'Milk and cream from local farms, pasteurized egg yolks, organic cane sugar, and the flavour: real vanilla beans, real cocoa, real pistachios, real raspberries.',
  'Sans colorant':'No colouring', 'Sans stabilisant':'No stabilizers', 'Sans additif':'No additives', '100 % naturel':'100% natural',
  'Lait d’ici':'Local milk', 'Crème d’ici':'Local cream', 'Jaunes d’œufs':'Egg yolks', 'Sucre de canne bio':'Organic cane sugar', 'La saveur, la vraie':'The real flavour',
  'Ce qu’il n’y a pas dans nos pintes':'What’s not in our pints', 'Les cinq ingrédients':'The five ingredients',
  'La vie au comptoir.':'Life at the counter.', 'Les soirs d’été, la file s’allonge sur Saint-Denis.':'On summer nights, the line stretches down Saint-Denis.',
  'Des pintes remplies à la main, une à une.':'Pints filled by hand, one by one.',
  'La file devant la Crémerie Meu Meu un soir d’été, sous le néon':'The line outside Crémerie Meu Meu on a summer night, under the neon',
  'Des pintes Meu Meu fraîchement remplies':'Freshly filled Meu Meu pints',
  '37 ans':'37 years', 'sur la rue Saint-Denis, avec la même base.':'on rue Saint-Denis, with the same base.',
  'Aujourd’hui, le chef Raphaël Bédard de Vilca, formé dans les grandes tables de Montréal, fait chaque crème glacée, sorbet et dessert glacé en petits lots à Bocal, notre cuisine du 4551, rue de Rouen.':'Today, chef Raphaël Bédard de Vilca, trained in Montréal’s fine-dining kitchens, makes every ice cream, sorbet and frozen dessert in small batches at Bocal, our kitchen at 4551 rue de Rouen.',
  'Tastet, 2025':'Tastet, 2025', 'Une pinte, ça vous dit ?':'Fancy a pint?', 'Voir la boutique':'Visit the shop',
  'Les quatre pintes du coffret':'The four pints in the box',
  'Sorbet framboise et basilic':'Raspberry basil sorbet', 'Sorbet lime et menthe':'Lime mint sorbet', 'Sorbet':'Sorbet',
  'Pinte de 500 ml. Sorbet.':'500 ml pint. Sorbet.', 'Framboise':'Raspberry', 'basilic':'basil', 'Lime':'Lime', 'menthe':'mint',
  'Framboise et basilic, en sorbet. Photo et liste d’ingrédients à venir.':'Raspberry and basil, as a sorbet. Photo and ingredient list coming soon.',
  'Lime et menthe, en sorbet. Photo et liste d’ingrédients à venir.':'Lime and mint, as a sorbet. Photo and ingredient list coming soon.',
  'Pintes de 500 ml (crème glacée et sorbet), coffret et bûche : produits alimentaires détaxés (TPS et TVQ à 0 %).':'500 ml pints (ice cream and sorbet), box and Yule log are zero-rated food items (GST and QST at 0%).',
  'Pintes de 500 ml, sorbets, le coffret des quatre classiques et la bûche des fêtes. Livraison dans quatre quartiers chaque mardi, ou cueillette au Bocal.':'500 ml pints, sorbets, the box of four classics and the holiday Yule log. Delivery in four neighbourhoods every Tuesday, or pickup at Bocal.',
  'Livraison gratuite':'Free delivery',
  'Dans le Plateau-Mont-Royal, le Mile End, Rosemont et Hochelaga, chaque mardi à partir du 10 novembre. Ailleurs, ou sous 44 $, cueillette au Bocal.':'In the Plateau-Mont-Royal, Mile End, Rosemont and Hochelaga, every Tuesday from November 10. Elsewhere, or under $44, pickup at Bocal.',
  'Plateau, Mile End, Rosemont, Hochelaga · chaque mardi':'Plateau, Mile End, Rosemont, Hochelaga · every Tuesday',
  'La livraison se fait pour les commandes de 44 $ et plus, dans le Plateau, le Mile End, Rosemont et Hochelaga. Complétez votre commande, ou passez la prendre au Bocal.':'Delivery is for orders of $44 and up, in the Plateau, Mile End, Rosemont and Hochelaga. Add to your order, or pick it up at Bocal.',
  'Livraison : Plateau, Mile End, Rosemont, Hochelaga':'Delivery: Plateau, Mile End, Rosemont, Hochelaga',
  'Entrez un code postal valide, par exemple H2J 2L1.':'Enter a valid postal code, for example H2J 2L1.',
  'Nous livrons seulement dans le Plateau-Mont-Royal, le Mile End, Rosemont et Hochelaga. Pour une autre adresse, choisissez la cueillette au Bocal.':'We only deliver in the Plateau-Mont-Royal, Mile End, Rosemont and Hochelaga. For another address, choose pickup at Bocal.', 'Pinte ':'Pint ',   'La vache Meu Meu, 100 % naturel':'The Meu Meu cow, 100% natural',
  'La devanture jaune de la Crémerie Meu Meu, 4458 rue Saint-Denis, avec l’équipe devant la vitrine':'The yellow storefront of Crémerie Meu Meu, 4458 rue Saint-Denis, with the team in front of the window',
  'Le chef Raphaël Bédard de Vilca au comptoir':'Chef Raphaël Bédard de Vilca at the counter',
  // Athletics
  'Bientôt':'Coming soon', 'La vache n’est pas encore arrivée.':'The cow hasn’t arrived yet.', 'Mais ça s’en vient.':'But she’s on her way.',
  'En attendant, une pinte ?':'Meanwhile, a pint?', 'La vache Meu Meu, intriguée':'The Meu Meu cow, intrigued',
  // Restaurants
  'Restaurants & événements':'Restaurants & events', 'Page en':'Page under', 'construction.':'construction.',
  'On prépare une page pour les restaurants, les traiteurs et les événements : formats, saveurs, livraison. Elle arrive bientôt.':'We’re preparing a page for restaurants, caterers and events: sizes, flavours, delivery. It’s coming soon.',
  'D’ici là, écrivez-nous directement :':'Until then, write to us directly:', 'Retour à l’accueil':'Back to home',
};
const norm = s => s.replace(/ /g, ' ').replace(/\s+/g, ' ').trim();
let LANG = 'fr';
try { LANG = localStorage.getItem('mm-lang') || ((navigator.language || 'fr').toLowerCase().startsWith('fr') ? 'fr' : 'en'); } catch(e) {}
if(LANG !== 'fr' && LANG !== 'en') LANG = 'fr';
document.documentElement.lang = LANG;
const tr = s => LANG === 'en' ? (EN[norm(s)] ?? s) : s;
const L = (fr, en) => LANG === 'en' ? en : fr;
const ATTRS = ['aria-label', 'placeholder', 'alt'];
function translateTree(root){
  const walk = n => {
    if(n.nodeType === 3){
      if(n.__fr === undefined) n.__fr = n.nodeValue;
      const key = norm(n.__fr); if(!key) return;
      if(LANG === 'en' && EN[key] !== undefined){ const lead = n.__fr.match(/^\s*/)[0], trail = n.__fr.match(/\s*$/)[0]; n.nodeValue = lead + EN[key] + trail; }
      else n.nodeValue = n.__fr;
      return;
    }
    if(n.nodeType !== 1 || n.nodeName === 'SCRIPT' || n.nodeName === 'STYLE') return;
    for(const a of ATTRS){ if(!n.hasAttribute(a)) continue; const c = a.replace(/-./g, m => m[1].toUpperCase()), k = 'fr' + c[0].toUpperCase() + c.slice(1);
      if(n.dataset[k] === undefined) n.dataset[k] = n.getAttribute(a);
      const en = EN[norm(n.dataset[k])]; n.setAttribute(a, LANG === 'en' && en !== undefined ? en : n.dataset[k]); }
    if(n.dataset && n.dataset.enHref){ if(n.dataset.frHref === undefined) n.dataset.frHref = n.getAttribute('href'); n.setAttribute('href', LANG === 'en' ? n.dataset.enHref : n.dataset.frHref); }
    n.childNodes.forEach(walk);
  };
  walk(root);
}
// anything the page renders later is translated as it appears
new MutationObserver(ms => { if(LANG === 'fr') return; for(const m of ms) m.addedNodes.forEach(translateTree); })
  .observe(document.body, { childList:true, subtree:true });

const root = document.documentElement;

/* ================= 3D pint (built from the photographed labels) ================= */
const canvas = $('gl');
const renderer = new THREE.WebGLRenderer({ canvas, antialias:true, alpha:true });
renderer.setPixelRatio(Math.min(devicePixelRatio, 2));
renderer.outputEncoding = THREE.sRGBEncoding;
renderer.toneMapping = THREE.ACESFilmicToneMapping;
renderer.physicallyCorrectLights = true;
const ENV_I = 0.8;

function makeEnv(r){
  const pm = new THREE.PMREMGenerator(r), room = new THREE.Scene();
  room.add(new THREE.Mesh(new THREE.BoxGeometry(40,24,40), new THREE.MeshBasicMaterial({ color:0x6d6a66, side:THREE.BackSide })));
  const panel = (w,h,x,y,z,c) => { const m = new THREE.Mesh(new THREE.PlaneGeometry(w,h), new THREE.MeshBasicMaterial({ color:c, side:THREE.DoubleSide })); m.position.set(x,y,z); m.lookAt(0,0,0); room.add(m); };
  panel(14,10,-14,6,10,new THREE.Color(4.2,4.0,3.8)); panel(8,14,16,3,2,new THREE.Color(1.6,1.6,1.7));
  panel(30,6,0,11.5,0,new THREE.Color(1.8,1.8,1.8)); panel(10,10,4,2,-18,new THREE.Color(1.2,1.15,1.1));
  return pm.fromScene(room, 0.035).texture;
}
function lights(scene){
  const key = new THREE.DirectionalLight(0xfff4e6, 2.6); key.position.set(-6,10,8); scene.add(key);
  scene.add(new THREE.HemisphereLight(0xffffff, 0x6b6157, 0.2));
}
const scene = new THREE.Scene(); scene.environment = makeEnv(renderer); lights(scene);
const camera = new THREE.PerspectiveCamera(26, 1, 0.1, 300);

const R_TOP = 4.65, R_BOT = 4.0, H = 8.8, LID_R = 5.02, LID_Y0 = 8.15, LID_TOP = 9.78, SEG = 160;
const bodyGeo = new THREE.CylinderGeometry(R_TOP, R_BOT, H, SEG, 1, true); bodyGeo.translate(0, H/2, 0);
const footGeo = new THREE.LatheGeometry([[R_BOT,.02],[R_BOT+.03,-.08],[R_BOT-.02,-.22],[R_BOT-.18,-.26],[.01,-.26]].map(p=>new THREE.Vector2(p[0],p[1])), SEG);
const lidPts = [[4.86,LID_Y0-.05],[4.93,LID_Y0],[4.97,LID_Y0+.4],[LID_R,9.7],[LID_R+.02,9.82]].map(p=>new THREE.Vector2(p[0],p[1]));
for(let i=0;i<=10;i++){ const a=i/10*Math.PI; lidPts.push(new THREE.Vector2(LID_R-.17+Math.cos(a)*.19, 9.9+Math.sin(a)*.17)); }
[[4.70,9.92],[4.68,9.84],[4.66,LID_TOP]].forEach(p=>lidPts.push(new THREE.Vector2(p[0],p[1])));
const lidGeo = new THREE.LatheGeometry(lidPts, SEG);
const lidTopGeo = new THREE.CircleGeometry(4.67, SEG); lidTopGeo.rotateX(-Math.PI/2); lidTopGeo.translate(0, LID_TOP, 0);
const rimGeo = new THREE.TorusGeometry(R_TOP-.02, .09, 12, SEG); rimGeo.rotateX(Math.PI/2); rimGeo.translate(0, H+.02, 0);

function canvasTex(w,h,draw){ const c=document.createElement('canvas'); c.width=w; c.height=h; draw(c.getContext('2d'),w,h); const t=new THREE.CanvasTexture(c); t.encoding=THREE.sRGBEncoding; t.anisotropy=8; return t; }
const skirtTex = canvasTex(2048,256,(g,w,h)=>{
  g.fillStyle='#efede8'; g.fillRect(0,0,w,h);
  for(let i=0;i<9000;i++){ g.fillStyle=`rgba(0,0,0,${Math.random()*.025})`; g.fillRect(Math.random()*w,Math.random()*h,2,2); }
  g.strokeStyle='rgba(120,112,100,.28)'; g.lineWidth=2.2; for(let k=-2;k<3;k++){ g.beginPath(); g.moveTo(k*w/2.2,h); g.lineTo(k*w/2.2+w/1.6,0); g.stroke(); }
  g.strokeStyle='rgba(255,255,255,.55)'; g.lineWidth=1.2; for(let k=-2;k<3;k++){ g.beginPath(); g.moveTo(k*w/2.2+3,h); g.lineTo(k*w/2.2+w/1.6+3,0); g.stroke(); }
});
const paperBump = canvasTex(512,512,(g,w,h)=>{ const id=g.createImageData(w,h); for(let i=0;i<id.data.length;i+=4){ const v=128+(Math.random()-.5)*60; id.data[i]=id.data[i+1]=id.data[i+2]=v; id.data[i+3]=255; } g.putImageData(id,0,0); });
paperBump.encoding = THREE.LinearEncoding; paperBump.wrapS = paperBump.wrapT = THREE.RepeatWrapping; paperBump.repeat.set(10,3);
const shadowTex = canvasTex(256,256,(g,w,h)=>{ const gr=g.createRadialGradient(w/2,h/2,0,w/2,h/2,w/2); gr.addColorStop(0,'rgba(0,0,0,.5)'); gr.addColorStop(.45,'rgba(0,0,0,.24)'); gr.addColorStop(1,'rgba(0,0,0,0)'); g.fillStyle=gr; g.fillRect(0,0,w,h); });
const paperMat = new THREE.MeshPhysicalMaterial({ color:0xf1efea, roughness:.82, sheen:.4, sheenRoughness:.8, envMapIntensity:ENV_I, bumpMap:paperBump, bumpScale:.004 });
const skirtMat = new THREE.MeshPhysicalMaterial({ map:skirtTex, roughness:.8, sheen:.4, sheenRoughness:.8, envMapIntensity:ENV_I, bumpMap:paperBump, bumpScale:.004, side:THREE.DoubleSide });

const loader = new THREE.TextureLoader();
const load = (url, srgb=true) => new Promise((res,rej)=>loader.load(url, t=>{ if(srgb) t.encoding=THREE.sRGBEncoding; t.anisotropy=8; res(t); }, undefined, rej));

function buildPot(f, tex, withShadow=true){
  const pot = new THREE.Group(), spinner = new THREE.Group(); pot.add(spinner);
  const labelMat = new THREE.MeshPhysicalMaterial({ map:tex.body, envMapIntensity:ENV_I, roughness:.62, clearcoat:.45, clearcoatRoughness:.32, clearcoatMap:tex.mask, sheen:.35, sheenRoughness:.8, bumpMap:paperBump, bumpScale:.003 });
  const body = new THREE.Mesh(bodyGeo, labelMat); body.rotation.y = Math.PI - f.logo*Math.PI/180; spinner.add(body);
  spinner.add(new THREE.Mesh(footGeo, paperMat), new THREE.Mesh(rimGeo, paperMat), new THREE.Mesh(lidGeo, skirtMat));
  spinner.add(new THREE.Mesh(lidTopGeo, new THREE.MeshPhysicalMaterial({ map:tex.lid, envMapIntensity:ENV_I, roughness:.6, clearcoat:.35, clearcoatRoughness:.35, sheen:.3, bumpMap:paperBump, bumpScale:.003 })));
  if(withShadow){
    const sh = new THREE.Mesh(new THREE.PlaneGeometry(13,13), new THREE.MeshBasicMaterial({ map:shadowTex, transparent:true, depthWrite:false, toneMapped:false }));
    sh.rotation.x = -Math.PI/2; sh.position.y = -.27; sh.scale.set(1,.92,1); pot.add(sh); pot.userData.shadow = sh;
  }
  pot.userData.spinner = spinner;
  return pot;
}

/* ================= hero carousel ================= */
let idx = 0, pots = {}, current = null, anim = null, view = { halfW: 20 };
const ease = { out: t => 1 - Math.pow(1 - t, 4), inn: t => t*t*t, io: t => t<.5 ? 4*t*t*t : 1 - Math.pow(-2*t+2,3)/2 };

let CAP_H = .7;                                                               // cap height of the titling face (em), measured once the font is ready
function measureCap(){ try { const c = document.createElement('canvas').getContext('2d'); c.font = '900 100px "Londrina Solid"'; const m = c.measureText('H'); if(m.actualBoundingBoxAscent) CAP_H = m.actualBoundingBoxAscent / 100; } catch(e) {} }
if(document.fonts) document.fonts.load('900 100px "Londrina Solid"').then(() => { measureCap(); fitWord(); });
function fitWord(){
  const w = $('word'), hero = $('accueil'); w.style.fontSize = '100px';
  const now = w.getBoundingClientRect().width || 1;
  const byWidth = 100 * (innerWidth * (innerWidth < 760 ? .9 : .86)) / now;   // the whole word stays on screen
  const byHeight = (hero.clientHeight || innerHeight) * .56 / CAP_H;       // capitals fill about half the stage
  w.style.fontSize = Math.min(byWidth, byHeight) + 'px';
  placeCow();
}
// the cow leaps over the top-right corner of the word
function placeCow(){
  const w = $('word'), cow = $('cowHero'), hero = $('accueil'); if(!cow || !hero.clientWidth) return;
  // layout box (ignores the slide-in transform): centred on (offsetLeft, offsetTop)
  const ww = w.offsetWidth, right = w.offsetLeft + ww/2, cy = w.offsetTop;
  const fs = parseFloat(w.style.fontSize) || 100;
  const cw = Math.max(96, Math.min(300, ww * .2)); const ch = cw * 400/623;
  const capTop = cy - fs*CAP_H/2;                                           // top of the capitals
  cow.style.width = cw + 'px';
  cow.style.left = Math.min(hero.clientWidth - cw - 8, right - cw*.78) + 'px';
  cow.style.top = Math.max(8, capTop - ch*.72) + 'px';
}
function paint(i, dir){
  const f = FLAVOURS[i];
  root.style.setProperty('--bg', f.bg); root.style.setProperty('--fg', f.fg);
  $('fname').textContent = tr(f.name); $('fdesc').textContent = tr(f.desc);
  [...$('dots').children].forEach((b,k)=>b.setAttribute('aria-current', k===i));
  const w = $('word');
  if(!dir || reduce){ w.textContent = tr(f.word); fitWord(); return; }
  w.style.setProperty('--dir', dir); w.classList.add('out');
  setTimeout(() => {
    w.classList.remove('out'); w.classList.add('in'); w.textContent = tr(f.word); fitWord();
    requestAnimationFrame(() => requestAnimationFrame(() => w.classList.remove('in')));
  }, 380);
}
function go(dir, target){
  if(anim || !current) return;
  const next = target ?? (idx + dir + FLAVOURS.length) % FLAVOURS.length;
  if(next === idx) return;
  const from = current, to = pots[FLAVOURS[next].id];
  idx = next; paint(idx, dir);
  if(reduce){ scene.remove(from); to.position.set(0,0,0); to.userData.spinner.rotation.y = 0; scene.add(to); current = to; return; }
  const off = view.halfW + 9;
  to.position.set(dir*off, 0, 0); scene.add(to);
  anim = { t0: performance.now(), from, to, dir, off, fromX: from.position.x };
}
$('prev').addEventListener('click', () => go(-1));
$('next').addEventListener('click', () => go(1));
addEventListener('keydown', e => {
  if(e.target.closest('input,textarea')) return;
  const hero = $('accueil').getBoundingClientRect(); if(hero.bottom < 100) return;
  if(e.key === 'ArrowRight') go(1); else if(e.key === 'ArrowLeft') go(-1);
});
FLAVOURS.forEach((f,k) => { const b = document.createElement('button'); b.type='button'; b.setAttribute('aria-label', f.name); b.addEventListener('click', () => go(k > idx ? 1 : -1, k)); $('dots').append(b); });

function resize(){
  const w = canvas.clientWidth, h = canvas.clientHeight; if(!w || !h) return;
  renderer.setSize(w, h, false);
  camera.aspect = w / h;
  const narrow = w / h < 0.85;
  const dist = narrow ? 82 + (0.85 - w/h) * 95 : 66;   // pot about half the stage height
  camera.position.set(0, 13, dist); camera.userData.lookY = narrow ? 3.4 : 4.4; camera.lookAt(0, camera.userData.lookY, 0); camera.updateProjectionMatrix();
  view.halfW = dist * Math.tan(THREE.MathUtils.degToRad(camera.fov/2)) * camera.aspect;
  fitWord();
}
addEventListener('resize', resize);

const ENTER = 1500, EXIT = 560;
/* depth parallax: the pot (camera) moves most, the cow less, the word least */
const par = { x:0, y:0, tx:0, ty:0, s:0 };
if(!reduce){
  addEventListener('pointermove', e => { if(e.pointerType !== 'mouse') return; par.tx = e.clientX / innerWidth - .5; par.ty = e.clientY / innerHeight - .5; }, { passive:true });
  addEventListener('scroll', () => { par.s = Math.min(1, scrollY / (innerHeight || 1)); }, { passive:true });
}
function applyParallax(){
  par.x += (par.tx - par.x) * .06; par.y += (par.ty - par.y) * .06;
  const st = $('accueil').style;
  st.setProperty('--wx', (-par.x * 14) + 'px'); st.setProperty('--wy', (-par.y * 8 + par.s * 60) + 'px');
}
const swipe = { active:false, dx:0 };
function frame(now){
  const t = now / 1000;
  if(current && !anim){
    current.userData.spinner.rotation.y = reduce ? 0 : Math.sin(t*.45) * .16;
    current.userData.spinner.position.y = reduce ? 0 : Math.sin(t*.9) * .35 + .2;
    if(current.userData.shadow) current.userData.shadow.scale.setScalar(1 - current.userData.spinner.position.y*.05);
    // finger drag: the pot follows the swipe, then springs back if it wasn't far enough
    const target = swipe.active ? swipe.dx * view.halfW * 2 / (canvas.clientWidth || 1) : 0;
    current.position.x += (target - current.position.x) * (swipe.active ? .5 : .18);
    current.userData.spinner.rotation.y += current.position.x * .06;
  }
  if(anim){
    const e = now - anim.t0;
    const te = Math.min(1, e / EXIT), ti = Math.min(1, e / ENTER);
    anim.from.position.x = anim.fromX - anim.dir * anim.off * ease.inn(te);
    anim.from.userData.spinner.rotation.y += anim.dir * .02;
    const k = ease.out(ti);
    anim.to.position.x = anim.dir * anim.off * (1 - k);
    // one full turn that lands exactly on the idle sway, so there is no jump when the float takes over
    anim.to.userData.spinner.rotation.y = anim.dir * Math.PI * 2 * (1 - k) + Math.sin(t*.45) * .16 * k;
    anim.to.userData.spinner.position.y = Math.sin(t*.9) * .35 * k + .2;
    if(anim.to.userData.shadow) anim.to.userData.shadow.scale.setScalar(1 - anim.to.userData.spinner.position.y*.05);
    if(te >= 1 && anim.from.parent) scene.remove(anim.from);
    if(ti >= 1){ current = anim.to; anim = null; }
  }
  if(route === 'home'){
    applyParallax();
    camera.position.x = par.x * 2.4; camera.position.y = 13 + par.y * 1.6 - par.s * 3;
    camera.lookAt(0, camera.userData.lookY ?? 4.4, 0);
    renderer.render(scene, camera);
  }
  requestAnimationFrame(frame);
}

/* ================= pages (hash routes) ================= */
let route = 'home';
function showRoute(){
  const h = location.hash.replace('#','');
  const pid = h.startsWith('produit-') ? h.slice(8) : null;
  const next = h === 'maison' ? 'maison' : h === 'restos' ? 'restos' : h === 'athletics' ? 'athletics' : (pid && PRODUCTS.some(p=>p.id===pid)) ? 'produit' : 'home';
  const changed = next !== route || next === 'produit'; route = next;
  $('view-home').hidden = route !== 'home';
  $('view-produit').hidden = route !== 'produit';
  $('view-maison').hidden = route !== 'maison';
  $('view-restos').hidden = route !== 'restos';
  $('view-athletics').hidden = route !== 'athletics';
  if(route === 'athletics' && changed){ const r = document.querySelector('.cowq'); if(r){ r.style.animation = 'none'; void r.getBoundingClientRect(); r.style.animation = ''; } }
  document.querySelectorAll('.nav a').forEach(a => a.removeAttribute('aria-current'));
  const navKey = route === 'home' ? (h === 'boutique' ? 'boutique' : '_') : route === 'produit' ? 'boutique' : route;
  const active = document.querySelector(`.nav a[href="#${navKey}"]`);
  if(active) active.setAttribute('aria-current', 'page');
  $('hdr').classList.toggle('scrolled', route !== 'home' || scrollY > innerHeight * .6);
  if(route === 'produit') renderProduct(pid); else document.title = 'Crémerie Meu Meu | Crème glacée artisanale à Montréal';
  if(typeof syncBar === 'function') syncBar();
  if(route === 'home'){
    resize();
    if(h === 'boutique'){ const y = $('boutique').getBoundingClientRect().top + scrollY - 72; window.scrollTo({ top: y, behavior: changed || reduce ? 'auto' : 'smooth' }); }
    else if(changed || h === 'accueil') window.scrollTo(0, 0);
  } else if(changed) window.scrollTo(0, 0);
}
addEventListener('hashchange', showRoute);
document.addEventListener('click', e => {        // same-hash clicks still scroll to the shop
  const a = e.target.closest('a[href="#boutique"]'); if(a && location.hash === '#boutique'){ e.preventDefault(); showRoute(); }
});

/* ================= shop ================= */
const BASE = ['Lait', 'crème 10 %', 'jaunes d’œufs pasteurisés', 'sucre de canne bio'];
const TRACES = 'Contient : lait et œufs. Peut contenir des traces de noix.';
const PRODUCTS = [
  { id:'chocolat',  flav:'chocolat',  name:'Chocolat hollandais',   desc:'Pinte de 500 ml. Cacao hollandais, profond et doux.', price:14,
    long:'Un chocolat franc et rond, fait avec du cacao hollandais pur. Pas de pépites, pas de sirop : juste le cacao dans notre crème anglaise.',
    ingr:[...BASE, 'cacao hollandais'], allerg:TRACES },
  { id:'vanille',   flav:'vanille',   name:'Vanille de Madagascar', desc:'Pinte de 500 ml. De vraies gousses, rien d’autre.',   price:14,
    long:'La recette d’origine. Des gousses de vanille de Madagascar infusées dans la crème anglaise, et rien d’autre.',
    ingr:[...BASE, 'vanille de Madagascar'], allerg:TRACES },
  { id:'pistache',  flav:'pistache',  name:'Pistache',              desc:'Pinte de 500 ml. De vraies pistaches, pas de vert.',  price:14,
    long:'Des pistaches broyées dans la crème anglaise. Sa couleur vient de la noix, pas d’un colorant.',
    ingr:[...BASE, 'pistaches'], allerg:'Contient : lait, œufs et noix (pistaches).' },
  { id:'framboise', flav:'framboise', name:'Framboise',             desc:'Pinte de 500 ml. De vraies framboises.',              price:14,
    long:'De vraies framboises dans une crème anglaise douce. Acidulée, fruitée, sans arôme ajouté.',
    ingr:[...BASE, 'framboises'], allerg:TRACES },
  { id:'sorbet-framboise-basilic', name:'Sorbet framboise et basilic', desc:'Pinte de 500 ml. Sorbet.', price:13, tag:'Sorbet',
    long:'Framboise et basilic, en sorbet. Photo et liste d’ingrédients à venir.', ph:{ bg:'linear-gradient(135deg,#C8285A 0 58%,#4E7D3A 58%)', title:'Framboise<br>basilic' }, swatch:'#C8285A' },
  { id:'sorbet-lime-menthe', name:'Sorbet lime et menthe', desc:'Pinte de 500 ml. Sorbet.', price:13, tag:'Sorbet',
    long:'Lime et menthe, en sorbet. Photo et liste d’ingrédients à venir.', ph:{ bg:'linear-gradient(135deg,#9BC53D 0 58%,#2E8B6A 58%)', title:'Lime<br>menthe' }, swatch:'#9BC53D' },
  { id:'coffret', name:'Le coffret des quatre', desc:'Vanille, chocolat, pistache et framboise : quatre pintes de 500 ml.', price:44, tag:'Idée cadeau',
    long:'Nos quatre classiques réunis dans une boîte : vanille de Madagascar, chocolat hollandais, pistache et framboise. Toujours ces quatre saveurs, pour offrir ou pour soi.',
    allerg:'Contient : lait, œufs et noix (pistaches).' },
  { id:'buche', name:'Bûche de Noël glacée', desc:'6 à 8 portions. Quantités limitées.', price:48, tag:'Temps des fêtes', ph:{ bg:'var(--navy)', title:'Bûche<br>de Noël' }, swatch:'var(--navy)',
    long:'La bûche glacée des fêtes, faite à Bocal par le chef Raphaël. Quantités limitées : réservez la vôtre avant le 15 décembre.',
    allerg:'Liste des ingrédients et des allergènes à venir.' },
];
/* Prix, disponibilité et stock : Shopify fait foi. Les taxes sont calculées par Shopify au paiement. */
// Confirmed merchant prices are a display fallback, never an authorization to sell.
const MM_CONFIRMED_PRICES = { chocolat:14, vanille:14, pistache:14, framboise:14, 'sorbet-framboise-basilic':14, 'sorbet-lime-menthe':14, coffret:45, buche:48 };
PRODUCTS.forEach(p => {
  p.price = MM_CONFIRMED_PRICES[p.id];
  const s = SHOP.products && SHOP.products[p.id];
  const hasPrice = s && s.price !== null && s.price !== undefined && s.price !== '' && Number.isFinite(Number(s.price)) && Number(s.price) > 0;
  const hasVariant = s && s.variant;
  if (hasPrice && hasVariant) {
    p.variant = s.variant;
    p.price = Number(s.price) / 100;
    p.available = Boolean(s.available);
    p.stock = s.stock;
  } else {
    p.variant = null;
    p.available = false;
    p.stock = 0;
    console.warn('Meu Meu: Shopify product data unavailable for', p.id);
  }
});
const FREE_FROM = 44;                                              // livraison (gratuite) seulement pour les commandes de 44 $ et plus
/* Livraison seulement dans 4 quartiers, par code postal (3 premiers caractères).
   Approximation : H2L, H2K et H2X débordent un peu sur le Centre-Sud et le centre-ville. À valider avant la mise en ligne. */
const ZONES = {
  'Plateau-Mont-Royal': ['H2H','H2J','H2L','H2T','H2W','H2X'],
  'Mile End':           ['H2T','H2V'],
  'Rosemont':           ['H1T','H1X','H1Y','H2G','H2S'],
  'Hochelaga':          ['H1V','H1W','H2K'],
};
const zoneOf = cp => Object.keys(ZONES).find(z => ZONES[z].includes(cp.slice(0,3))) || null;
const BUCHE_DEADLINE = new Date('2026-12-15T23:59:59-05:00');     // une semaine avant la dernière livraison (22 déc.)
const today = new Date(); today.setHours(0,0,0,0);
const DELIVERY_DATES = ['2026-11-10','2026-11-17','2026-11-24','2026-12-01','2026-12-08','2026-12-15','2026-12-22']
  .filter(d => new Date(d + 'T12:00:00') > today);
const SHOTS = {};
let cart = {};
try { cart = JSON.parse(localStorage.getItem('mm-cart') || '{}') || {}; } catch(e) { cart = {}; }
function cleanCart(c){ const out = {}; if(!c || typeof c !== 'object' || Array.isArray(c)) return out;
  for(const p of PRODUCTS){ const v = c[p.id]; if(typeof v !== 'number' || !Number.isFinite(v)) continue; const q = Math.floor(v); if(q > 0) out[p.id] = q; } return out; }
cart = cleanCart(cart);
const saveCart = () => { try { localStorage.setItem('mm-cart', JSON.stringify(cart)); } catch(e) {} };
const cartCount = () => Object.values(cart).reduce((a,b)=>a+b,0);
const pintCount = () => PRODUCTS.reduce((n,p) => n + (cart[p.id]||0) * (p.flav ? 1 : p.id === 'coffret' ? 4 : 0), 0);
const deliveryOK = () => totals().sub >= FREE_FROM;
function money(v){ return LANG === 'en' ? '$' + v.toFixed(2) : v.toFixed(2).replace('.', ',') + '\u00A0$'; }
function totals(delivery){
  let sub = 0;
  for(const [id,q] of Object.entries(cart)){ const p = PRODUCTS.find(x=>x.id===id); if(!p) continue; sub += p.price*q; }
  return { sub, total: sub };
}
function syncCount(){
  const n = cartCount(); $('cartN').textContent = n; document.querySelector('#hdr .cart').dataset.n = n;
  $('cbN').textContent = n; $('cbT').textContent = money(totals().sub); syncBar();
}
function syncBar(){
  const show = cartCount() > 0 && !$('drawer').classList.contains('open') && (route === 'home' || route === 'produit');
  $('cartbar').hidden = !show; document.body.classList.toggle('has-bar', show);
}
function addToCart(id, q){
  if(id === 'buche'){ const left = bucheLeft(); if(left !== null) q = Math.min(q, Math.max(0, left - (cart.buche||0))); if(q <= 0){ toast('Il ne reste plus de bûches.'); return 0; } }
  cart[id] = (cart[id]||0) + q; saveCart(); syncCount(); renderCart();
  const c = $('hdr').querySelector('.cart'); c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump');
  return q;
}

/* ---------- bûche : stock partagé (db) ---------- */
const bucheClosed = () => new Date() > BUCHE_DEADLINE;
const bucheProduct = () => PRODUCTS.find(p => p.id === 'buche');
const bucheLeft = () => { const p = bucheProduct(); if(p.available === false) return 0; return typeof p.stock === 'number' ? Math.max(0, p.stock) : null; };
function bucheStatus(){
  if(bucheClosed()) return { open:false, text:tr('Précommandes terminées pour cette année.') };
  const left = bucheLeft();
  if(left === 0) return { open:false, text:tr('Épuisée. Merci !') };
  const qty = left == null ? L('Quantités limitées, nombre annoncé bientôt.','Limited quantities, number to be announced.') : L(`Plus que ${left} bûche${left>1?'s':''} disponible${left>1?'s':''}.`, `Only ${left} Yule log${left>1?'s':''} left.`);
  return { open:true, text:`${qty} ${L('Commandes jusqu’au 15 décembre.','Orders until December 15.')}` };
}
function paintBuche(){
  const s = bucheStatus();
  document.querySelectorAll('[data-buche-status]').forEach(el => el.textContent = s.text);
  document.querySelectorAll('.ctl[data-id="buche"]').forEach(ctl => { const b = ctl.querySelector('.add'); b.disabled = !s.open; b.textContent = tr(s.open ? 'Ajouter' : 'Indisponible'); if(!s.open) ctl.dataset.state = 'idle'; });
  PRODUCTS.filter(p => p.id !== 'buche' && p.available === false).forEach(p => document.querySelectorAll(`.ctl[data-id="${p.id}"]`).forEach(ctl => { const b = ctl.querySelector('.add'); b.disabled = true; b.textContent = tr('Indisponible'); ctl.dataset.state = 'idle'; }));
}
/* ---------- cards ---------- */
const ctlHTML = (p) => `<div class="ctl" data-id="${p.id}" data-state="idle">
    <button class="add" type="button">Ajouter</button>
    <div class="qty" role="group" aria-label="${L('Quantité de ','Quantity of ')}${tr(p.name)}">
      <button class="q minus" type="button" aria-label="Retirer une">−</button>
      <output class="n">1</output>
      <button class="q plus" type="button" aria-label="Ajouter une">+</button>
      <button class="ok" type="button">OK</button>
    </div>
    <span class="done" aria-hidden="true">Ajouté ✓</span>
  </div>`;
const PHOTOS = { vanille:A('vanille.webp'), chocolat:A('chocolat.webp'), pistache:A('pistache.webp'), framboise:A('framboise.webp') };
function shotHTML(p, big){
  if(p.flav) return `<div class="shot photo"><img src="${PHOTOS[p.flav]}" alt="${L('Pinte ','Pint of ')}${tr(p.name)}" width="740" height="867" loading="lazy"></div>`;
  if(p.id === 'coffret') return `<div class="shot" style="background:var(--blue)"><span class="tag">${p.tag}</span><img data-shot="coffret" ${SHOTS.coffret ? `src="${SHOTS.coffret}"` : ''} alt="Les quatre pintes du coffret" width="520" height="640" style="width:92%"></div>`;
  return `<div class="shot ph" style="background:${p.ph.bg}"><span class="tag">${p.tag}</span><div class="ph-in"><strong>${p.ph.title}</strong><small>Photo à venir</small></div></div>`;
}
function renderShop(){
  $('grid').innerHTML = PRODUCTS.map(p => `<article class="card">
      <a class="card-link" href="#produit-${p.id}" aria-label="${tr(p.name)}${L(' : voir la fiche',': see details')}">${shotHTML(p)}</a>
      <div class="info"><h3><a href="#produit-${p.id}">${p.name}</a></h3><p>${p.desc}</p>
      ${p.id === 'buche' ? '<p class="stock" data-buche-status></p>' : ''}
      <div class="buy"><span class="price">${money(p.price)}</span>${ctlHTML(p)}</div></div></article>`).join('');
  paintBuche();
}
document.addEventListener('click', e => {
  const ctl = e.target.closest('.ctl'); if(!ctl) return;
  const n = ctl.querySelector('.n'); const id = ctl.dataset.id;
  const max = id === 'buche' && bucheLeft() !== null ? Math.max(1, bucheLeft() - (cart.buche||0)) : Infinity;
  if(e.target.closest('.add')){ if(e.target.closest('.add').disabled) return; n.textContent = 1; ctl.dataset.state = 'pick'; ctl.querySelector('.plus').focus(); }
  else if(e.target.closest('.plus')){ n.textContent = Math.min(max, +n.textContent + 1); bounce(n); }
  else if(e.target.closest('.minus')){ const v = +n.textContent - 1; if(v < 1){ ctl.dataset.state = 'idle'; ctl.querySelector('.add').focus(); } else { n.textContent = v; bounce(n); } }
  else if(e.target.closest('.ok')){
    const p = PRODUCTS.find(x => x.id === id); const q = addToCart(id, +n.textContent);
    if(!q){ ctl.dataset.state = 'idle'; return; }
    ctl.dataset.state = 'done';
    toast(L(`${q} × ${p.name} ajouté${q>1?'s':''} à la commande`, `${q} × ${tr(p.name)} added to your order`));
    setTimeout(() => { ctl.dataset.state = 'idle'; }, 1400);
  }
});
function bounce(el){ el.classList.remove('pop'); void el.offsetWidth; el.classList.add('pop'); }

/* ---------- fiche produit ---------- */
function renderProduct(id){
  const p = PRODUCTS.find(x => x.id === id); if(!p) return;
  const f = p.flav ? byId[p.flav] : null;
  const bg = f ? f.card : p.id === 'coffret' ? 'var(--blue)' : p.ph.bg;
  const fg = f ? (f.id === 'vanille' ? 'var(--navy)' : 'var(--cream)') : 'var(--cream)';
  let details = '';
  if(p.flav) details = `
    <div class="pp-row"><dt>Format</dt><dd>Pinte de 500 ml</dd></div>
    <div class="pp-row"><dt>Ingrédients</dt><dd>${p.ingr.map(tr).join(', ')}.</dd></div>
    <div class="pp-row"><dt>Allergènes</dt><dd>${p.allerg}</dd></div>
    <div class="pp-row"><dt>Conservation</dt><dd>Garder congelé. Laisser tempérer 5 minutes avant de servir.</dd></div>`;
  else if(p.id === 'coffret') details = `
    <div class="pp-row"><dt>Contenu</dt><dd>4 pintes de 500 ml : vanille de Madagascar, chocolat hollandais, pistache, framboise.</dd></div>
    <div class="pp-row"><dt>Ingrédients</dt><dd>${BASE.map(tr).join(', ')}${L(', et la saveur de chaque pinte (vanille de Madagascar, cacao hollandais, pistaches, framboises).',', and each pint’s flavour (Madagascar vanilla, Dutch cocoa, pistachios, raspberries).')}</dd></div>
    <div class="pp-row"><dt>Allergènes</dt><dd>${p.allerg}</dd></div>
    <div class="pp-row"><dt>Conservation</dt><dd>Garder congelé.</dd></div>`;
  else if(p.tag === 'Sorbet') details = `
    <div class="pp-row"><dt>Format</dt><dd>Pinte de 500 ml</dd></div>
    <div class="pp-row"><dt>Ingrédients</dt><dd>Liste des ingrédients et des allergènes à venir.</dd></div>
    <div class="pp-row"><dt>Conservation</dt><dd>Garder congelé. Laisser tempérer 5 minutes avant de servir.</dd></div>`;
  else details = `
    <div class="pp-row"><dt>Format</dt><dd>6 à 8 portions</dd></div>
    <div class="pp-row"><dt>Disponibilité</dt><dd data-buche-status></dd></div>
    <div class="pp-row"><dt>Livraison</dt><dd>Les mardis jusqu’au 22 décembre, ou cueillette au Bocal.</dd></div>
    <div class="pp-row"><dt>Ingrédients</dt><dd>${p.allerg}</dd></div>`;
  $('pp').innerHTML = `
    ${p.flav ? `<div class="pp-visual photo"><img src="${PHOTOS[p.flav]}" alt="Pinte ${p.name}" width="740" height="867"></div>` : `<div class="pp-visual" style="background:${bg};color:${fg}">
      <span class="pp-word" aria-hidden="true">${f ? f.word : p.id === 'coffret' ? 'Coffret' : p.id === 'buche' ? 'Bûche' : 'Sorbet'}</span>
      ${p.ph ? `<div class="ph-in"><strong>${p.ph.title}</strong><small>Photo à venir</small></div>`
        : `<img data-shot="${p.id}" ${SHOTS[p.id] ? `src="${SHOTS[p.id]}"` : ''} alt="${p.flav ? 'Pinte ' + p.name : 'Les quatre pintes du coffret'}" width="520" height="640">`}
    </div>`}
    <div class="pp-info">
      <a class="pp-back" href="#boutique">← Boutique</a>
      ${p.tag ? `<span class="pp-tag">${p.tag}</span>` : ''}
      <h1>${p.name}</h1>
      <p class="pp-lead">${p.long}</p>
      <div class="pp-buy"><span class="price big">${money(p.price)}</span>${ctlHTML(p)}</div>
      <dl class="pp-details">${details}</dl>
      <p class="fine">${L(`Livraison gratuite dans le Plateau, le Mile End, Rosemont et Hochelaga pour les commandes de ${FREE_FROM}\u00A0$ et plus. Ailleurs, cueillette au Bocal.`, `Free delivery in the Plateau, Mile End, Rosemont and Hochelaga for orders of $${FREE_FROM} and up. Elsewhere, pickup at Bocal.`)}</p>
    </div>`;
  paintBuche();
  document.title = tr(p.name) + ' · Meu Meu';
}

/* ---------- cart drawer + checkout ---------- */
let step = 'cart';
function openCart(){ setTimeout(syncBar, 0); renderCart(); setStep(cartCount() ? step === 'done' ? 'cart' : step : 'cart'); $('scrim').hidden = false; $('drawer').classList.add('open'); $('drawer').setAttribute('aria-hidden','false'); document.body.style.overflow = 'hidden'; setTimeout(()=>$('closeCart').focus(), 50); }
function closeCart(){ setTimeout(syncBar, 0); $('drawer').classList.remove('open'); $('drawer').setAttribute('aria-hidden','true'); $('scrim').hidden = true; document.body.style.overflow = ''; }
function setStep(s){ step = s; document.querySelectorAll('.pane').forEach(p => p.hidden = p.dataset.step !== s);
  const labels = { cart:'Votre commande', info:'Livraison ou cueillette', pay:'Paiement', done:'Merci !' }; $('drawerTitle').textContent = tr(labels[s]);
  document.querySelectorAll('.prog li').forEach(li => li.classList.toggle('on', ['cart','info','pay'].indexOf(li.dataset.s) <= ['cart','info','pay','done'].indexOf(s)));
  if(s === 'info') syncMode();
  $('drawerBody').scrollTop = 0; }
function totalsHTML(delivery){
  const t = totals(delivery);
  return `<dl class="tot"><div><dt>Sous-total</dt><dd>${money(t.sub)}</dd></div>
    ${delivery === undefined ? '' : `<div><dt>${delivery ? 'Livraison' : 'Cueillette au Bocal'}</dt><dd>Gratuite</dd></div>`}
    <div class="big"><dt>Total avant taxes</dt><dd>${money(t.total)}</dd></div></dl>
    <p class="fine">Les taxes applicables et le mode de livraison sont confirmés à la page de paiement.</p>`;
}
function renderCart(){
  const items = Object.entries(cart).filter(([,q]) => q > 0);
  $('cartList').innerHTML = items.length ? items.map(([id,q]) => {
    const p = PRODUCTS.find(x=>x.id===id); const f = p.flav ? byId[p.flav] : null;
    const sw = f ? f.card : p.id === 'coffret' ? 'var(--blue)' : p.swatch;
    return `<li><span class="sw" style="background:${sw}"></span><div class="li-txt"><b>${p.name}</b><small>${money(p.price)}${L(' ch.',' each')}</small></div>
      <div class="li-q" data-id="${id}"><button type="button" class="q" data-d="-1" aria-label="Retirer une ${p.name}">−</button><output>${q}</output><button type="button" class="q" data-d="1" aria-label="Ajouter une ${p.name}">+</button></div>
      <span class="li-amt">${money(p.price*q)}</span></li>`; }).join('')
    : `<li class="empty"><img src="${A('vache.png')}" alt="" class="on-cream" width="623" height="400"><span>Votre commande est vide. Ajoutez une pinte pour commencer.</span></li>`;
  $('cartTotals').innerHTML = items.length ? totalsHTML() : '';
  const sub = totals().sub;
  $('shipNote').innerHTML = !items.length ? '' :
    deliveryOK() ? L(`<b>Livraison gratuite débloquée</b> dans le Plateau, le Mile End, Rosemont et Hochelaga. Chaque mardi à partir du 10 novembre.`, `<b>Free delivery unlocked</b> in the Plateau, Mile End, Rosemont and Hochelaga. Every Tuesday from November 10.`) :
    L(`Plus que <b>${money(FREE_FROM - sub)}</b> pour débloquer la livraison gratuite (Plateau, Mile End, Rosemont, Hochelaga). Sinon, cueillette au Bocal.`, `Just <b>${money(FREE_FROM - sub)}</b> more to unlock free delivery (Plateau, Mile End, Rosemont, Hochelaga). Otherwise, pickup at Bocal.`);
  $('toInfo').disabled = !items.length;
}
$('cartList').addEventListener('click', e => {
  const b = e.target.closest('.q[data-d]'); if(!b) return;
  const id = b.parentElement.dataset.id; const d = +b.dataset.d;
  if(d > 0 && id === 'buche' && bucheLeft() !== null && (cart.buche||0) >= bucheLeft()){ toast('Il ne reste plus de bûches.'); return; }
  cart[id] = Math.max(0, (cart[id]||0) + d); if(!cart[id]) delete cart[id];
  saveCart(); syncCount(); renderCart();
});
document.querySelector('#hdr .cart').addEventListener('click', e => { e.preventDefault(); openCart(); });
$('closeCart').addEventListener('click', closeCart);
$('scrim').addEventListener('click', closeCart);
addEventListener('keydown', e => { if(e.key === 'Escape' && $('drawer').classList.contains('open')) closeCart(); });
$('toInfo').addEventListener('click', () => setStep('info'));
document.querySelectorAll('[data-back]').forEach(b => b.addEventListener('click', () => setStep(b.dataset.back)));

// delivery dates: every Tuesday from November 10 to December 22
const fmtDate = d => new Date(d + 'T12:00:00').toLocaleDateString(L('fr-CA','en-CA'), { weekday:'long', day:'numeric', month:'long' });
function renderDates(){ const v = $('f-date').value; $('f-date').innerHTML = DELIVERY_DATES.length ? DELIVERY_DATES.map(d => `<option value="${d}">${fmtDate(d)}</option>`).join('') : `<option value="">${tr('Aucune date de livraison restante')}</option>`; if(v) $('f-date').value = v; }
renderDates();
function syncMode(){
  const ok = deliveryOK() && DELIVERY_DATES.length;
  $('f-deliv').disabled = !ok; $('minNote').hidden = ok;
  if(!ok) $('f-pick').checked = true;
  const pick = $('f-pick').checked; $('deliveryBox').hidden = pick; $('pickupBox').hidden = !pick;
  $('f-cp').required = !pick;
}
$('f-deliv').addEventListener('change', syncMode); $('f-pick').addEventListener('change', syncMode); syncMode();

$('infoForm').addEventListener('submit', e => {
  e.preventDefault();
  const err = $('formErr'); err.hidden = true;
  const pick = $('f-pick').checked;
  const cp = $('f-cp').value.trim().toUpperCase().replace(/\s+/g,'');
  if(!pick){
    if(!/^[A-Z][0-9][A-Z][0-9][A-Z][0-9]$/.test(cp)){
      err.textContent = tr('Entrez un code postal valide, par exemple H2J 2L1.');
      err.hidden = false; $('f-cp').focus(); return;
    }
    if(!zoneOf(cp)){
      err.textContent = tr('Nous livrons seulement dans le Plateau-Mont-Royal, le Mile End, Rosemont et Hochelaga. Pour une autre adresse, choisissez la cueillette au Bocal.');
      err.hidden = false; $('f-cp').focus(); return;
    }
    $('f-cp').value = cp.slice(0,3) + ' ' + cp.slice(3);
  }
  if(!e.target.reportValidity()) return;
  goCheckout(pick, cp, e.target.querySelector('[type=submit]'));
});
const esc = s => String(s).replace(/[&<>"']/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]));
async function cartPost(url, body){
  const res = await fetch(SHOP.root + url, { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body: JSON.stringify(body) });
  if(!res.ok) throw Object.assign(new Error('cart'), { status: res.status });
  return res.json();
}
let payBtnEl = null;
const resetPay = () => { if(payBtnEl){ payBtnEl.disabled = false; payBtnEl.textContent = tr('Continuer vers le paiement'); } };
addEventListener('pageshow', resetPay);
/* Envoie le panier à Shopify avec le mode et le mardi choisis, puis ouvre la page de paiement Shopify. */
async function goCheckout(pick, cp, btn){
  payBtnEl = btn; btn.disabled = true; btn.textContent = tr('Un instant…');
  try {
    if(cart.buche && (bucheClosed() || (bucheLeft() !== null && cart.buche > bucheLeft()))){ toast('La bûche n’est plus disponible en cette quantité.'); setStep('cart'); resetPay(); return; }
    const items = Object.entries(cart).filter(([,q]) => q > 0).map(([id,q]) => ({ id: (PRODUCTS.find(p => p.id === id) || {}).variant, quantity: q }));
    if(!items.length || items.some(i => !i.id)){ toast('La boutique n’est pas encore configurée.'); resetPay(); return; }
    await cartPost('cart/clear.js', {});
    await cartPost('cart/add.js', { items });
    await cartPost('cart/update.js', {
      note: pick ? '' : $('f-note').value.trim(),
      attributes: {
        'Mode choisi': pick ? 'Cueillette au Bocal' : 'Livraison',
        'Mardi de livraison': pick ? '' : new Date($('f-date').value + 'T12:00:00').toLocaleDateString('fr-CA', { weekday:'long', day:'numeric', month:'long', year:'numeric' }),
        'Code postal vérifié': pick ? '' : cp.slice(0,3) + ' ' + cp.slice(3),
        'Langue': LANG
      }
    });
    try { localStorage.setItem('mm-pending', '1'); } catch(e) {}
    location.href = SHOP.root + 'checkout' + (LANG === 'en' ? '?locale=en' : '');
  } catch(e) {
    toast(e.status === 422 ? 'Un produit n’est plus disponible en cette quantité.' : 'Le paiement n’a pas pu s’ouvrir. Réessayez.');
    if(e.status === 422) setStep('cart');
    resetPay();
  }
}
let tt; function toast(msg){ const el = $('toast'); el.textContent = msg; el.classList.add('on'); clearTimeout(tt); tt = setTimeout(()=>el.classList.remove('on'), 1800); }

/* product shots rendered from the same 3D pints */
function renderShots(){
  const W = 520, Hh = 640;
  const c = document.createElement('canvas'); c.width = W; c.height = Hh;
  const r = new THREE.WebGLRenderer({ canvas:c, antialias:true, alpha:true, preserveDrawingBuffer:true });
  r.outputEncoding = THREE.sRGBEncoding; r.toneMapping = THREE.ACESFilmicToneMapping; r.physicallyCorrectLights = true; r.setPixelRatio(1);
  const s = new THREE.Scene(); s.environment = makeEnv(r); lights(s);
  const cam = new THREE.PerspectiveCamera(24, W/Hh, .1, 200);
  const shoot = (objs, camPos, look) => { s.children.filter(o=>o.userData.shot).forEach(o=>s.remove(o)); objs.forEach(o=>{ o.userData.shot = true; s.add(o); });
    cam.position.copy(camPos); cam.lookAt(look); cam.updateProjectionMatrix(); r.render(s, cam); return c.toDataURL('image/png'); };
  FLAVOURS.forEach(f => {
    const p = buildPot(f, pots[f.id].userData.tex); p.userData.spinner.rotation.y = -.25;
    SHOTS[f.id] = shoot([p], new THREE.Vector3(0, 12, 38), new THREE.Vector3(0, 4.6, 0));
  });
  const group = [];
  [['vanille',-5.3,-4.4],['chocolat',5.3,-4.4],['pistache',-5.3,5.4],['framboise',5.3,5.4]].forEach(([id,x,z]) => {
    const p = buildPot(byId[id], pots[id].userData.tex); p.position.set(x,0,z); p.userData.spinner.rotation.y = -x*.03; group.push(p);
  });
  cam.aspect = W/Hh; SHOTS.coffret = shoot(group, new THREE.Vector3(0, 34, 62), new THREE.Vector3(0, 3, .5));
  document.querySelectorAll('img[data-shot]').forEach(im => { if(SHOTS[im.dataset.shot]) im.src = SHOTS[im.dataset.shot]; });
  r.dispose();
}

/* ================= mobile ================= */
const mmenu = $('mmenu'), burger = $('burger');
function setMenu(open){
  burger.setAttribute('aria-expanded', open); burger.setAttribute('aria-label', tr(open ? 'Fermer le menu' : 'Ouvrir le menu')); burger.dataset.frAriaLabel = open ? 'Fermer le menu' : 'Ouvrir le menu';
  if(open){ mmenu.hidden = false; requestAnimationFrame(() => mmenu.classList.add('on')); document.body.style.overflow = 'hidden'; $('hdr').classList.add('scrolled'); }
  else { mmenu.classList.remove('on'); document.body.style.overflow = ''; setTimeout(() => { if(!mmenu.classList.contains('on')) mmenu.hidden = true; }, 250);
    $('hdr').classList.toggle('scrolled', route !== 'home' || scrollY > innerHeight * .6); }
}
burger.addEventListener('click', () => setMenu(burger.getAttribute('aria-expanded') !== 'true'));
mmenu.addEventListener('click', e => { if(e.target.closest('a')) setMenu(false); });
addEventListener('hashchange', () => { setMenu(false); syncBar(); });
$('cartbar').addEventListener('click', openCart);

// swipe between flavours on the hero: horizontal drags move the pot, vertical ones stay with the page
(() => {
  const hero = $('accueil'); let sx = 0, sy = 0, axis = null, t0 = 0;
  hero.addEventListener('touchstart', e => {
    if(anim || e.touches.length !== 1 || e.target.closest('button,a')) return;
    sx = e.touches[0].clientX; sy = e.touches[0].clientY; axis = null; t0 = performance.now(); swipe.dx = 0;
  }, { passive:true });
  hero.addEventListener('touchmove', e => {
    if(anim || e.touches.length !== 1) return;
    const dx = e.touches[0].clientX - sx, dy = e.touches[0].clientY - sy;
    if(!axis && Math.hypot(dx, dy) > 8) axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
    if(axis === 'x'){ swipe.active = true; swipe.dx = dx; }
  }, { passive:true });
  const end = () => {
    if(!swipe.active){ axis = null; return; }
    const dx = swipe.dx, fast = Math.abs(dx) / Math.max(1, performance.now() - t0) > .45;
    swipe.active = false; axis = null; swipe.dx = 0;
    if(Math.abs(dx) > hero.clientWidth * .22 || (fast && Math.abs(dx) > 30)) go(dx < 0 ? 1 : -1);
  };
  hero.addEventListener('touchend', end); hero.addEventListener('touchcancel', end);
})();

// drag the sheet's handle down to close it
(() => {
  const d = $('drawer'); let y0 = null, dy = 0;
  const start = e => { if(innerWidth > 760 || e.target.closest('button')) return; y0 = e.clientY; dy = 0; d.style.transition = 'none'; e.currentTarget.setPointerCapture(e.pointerId); };
  const move = e => { if(y0 === null) return; dy = Math.max(0, e.clientY - y0); d.style.transform = `translateY(${dy}px)`; };
  const end = () => { if(y0 === null) return; y0 = null; d.style.transition = ''; d.style.transform = ''; if(dy > 90) closeCart(); };
  ['grab', 'drawerTitle'].forEach(id => { const el = id === 'grab' ? $('grab') : d.querySelector('.d-head');
    el.addEventListener('pointerdown', start); el.addEventListener('pointermove', move); el.addEventListener('pointerup', end); el.addEventListener('pointercancel', end); });
})();

/* ---------- switching language ---------- */
function setLang(l){
  LANG = l; try { localStorage.setItem('mm-lang', l); } catch(e) {}
  document.documentElement.lang = l === 'en' ? 'en' : 'fr';
  document.querySelectorAll('.lang button').forEach(b => b.setAttribute('aria-pressed', b.dataset.l === l));
  translateTree(document.body);
  renderShop(); renderCart(); syncCount(); renderDates(); paintBuche();
  if(route === 'produit') renderProduct(location.hash.slice(9));
  paint(idx, 0);
  const st = { cart:'Votre commande', info:'Livraison ou cueillette', pay:'Paiement', done:'Merci !' }; $('drawerTitle').textContent = tr(st[step] || st.cart);
  translateTree(document.body);
}
document.querySelectorAll('.lang button').forEach(b => b.addEventListener('click', () => { setLang(b.dataset.l); if(b.closest('.mmenu')) setMenu(false); }));

/* ================= boot ================= */
renderShop();
syncCount(); renderCart();
paint(0, 0);
resize();
addEventListener('load', fitWord);
if(document.fonts) document.fonts.ready.then(fitWord);
addEventListener('scroll', () => $('hdr').classList.toggle('scrolled', route !== 'home' || scrollY > innerHeight * .6), { passive:true });
showRoute();
if(LANG !== 'fr') setLang(LANG); else document.querySelectorAll('.lang button').forEach(b => b.setAttribute('aria-pressed', b.dataset.l === 'fr'));
Promise.all(FLAVOURS.map(f => Promise.all([load(A(`${f.id}.jpg`)), load(A(`${f.id}-lid.jpg`)), load(A(`${f.id}-mask.png`), false)])
  .then(([body, lid, mask]) => { const p = buildPot(f, { body, lid, mask }); p.userData.tex = { body, lid, mask }; pots[f.id] = p; })))
  .then(() => {
    current = pots.vanille; scene.add(current); $('loading').hidden = true;
    renderShots();
  })
  .catch(() => { $('loading').textContent = 'Le pot n’a pas pu être chargé. Rechargez la page.'; });
(async () => {
  let pending = null; try { pending = localStorage.getItem('mm-pending'); } catch(e) {}
  if(pending){
    try {
      const c = await fetch(SHOP.root + 'cart.js', { headers:{ 'Accept':'application/json' } }).then(r => r.json());
      if(c.item_count === 0){ cart = {}; saveCart(); syncCount(); renderCart(); }
      try { localStorage.removeItem('mm-pending'); } catch(e) {}
    } catch(e) {}
  }
  if(SHOP.openCart) openCart();
})();
requestAnimationFrame(frame);
})();
